import { atom } from 'nanostores';
// Atom for tracking whether feedback should be displayed
export const $shouldDisplayFeedbackAtom = atom(false);
